import React from "react";
import { Box, Container } from "@mui/system";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

export default function Layout2Section2({ acf, accentColor = "#1e73be" }) {
  const useStyles = makeStyles({
    root: {
      boxShadowColor: "#FFF",
    },
  });

  return (
    <Box
      sx={{
        position: "relative",
        background: acf?.background_color ? acf.background_color : "#F0F0F0",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
          position: "relative",
          zIndex: 1,
          "&:after": {
            content: '""',
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            height: "60px",
            background: accentColor,
          },
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
            },
            position: "relative",
            zIndex: 1,
          }}
        >
          {acf?.feature_cards && acf?.feature_cards.length > 0 ? (
            <Grid
              container
              spacing={4}
              align="center"
              justifyContent={{ xs: "center" }} //centering the grid
              sx={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              {acf.feature_cards.map((featured_card, index) => (
                <Grid
                  item
                  xs={12}
                  md={4}
                  lg={4}
                  key={index}
                  sx={{
                    marginBottom: "20px",
                    display: "flex",
                  }}
                >
                  <Card
                    className={useStyles.root}
                    elevation={5}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      height: "100%",
                      width: "100%",
                      backgroundColor: "#fff",
                      color: "#000",
                      "&.MuiPaper-root": {
                        border: "1px solid rgba(99, 99, 99, 0.1)",
                        boxShadow:
                          "0px 3px 5px -1px rgba(255, 255, 255, 0.2),0px 5px 8px 0px rgba(255, 255, 255, 0.14),0px 1px 14px 0px rgba(255, 255, 255, 0.12)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        textAlign: "left",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100px",
                          height: "100px",
                        }}
                      >
                        <img
                          src={featured_card.icon.url}
                          alt={featured_card.icon.alt}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mb: 1,
                          }}
                        />
                      </Box>
                      <Typography
                        variant="h5"
                        component="h2"
                        sx={{
                          fontWeight: 600,
                          mt: 1,
                          mb: 1,
                        }}
                      >
                        {featured_card.title}
                      </Typography>
                      <Typography variant="p" component="p">
                        {featured_card.description}
                      </Typography>
                      {featured_card.additional_text &&
                      featured_card.additional_text !== "" ? (
                        <Typography
                          variant="body2"
                          component="p"
                          sx={{
                            mt: 1,
                          }}
                        >
                          {featured_card.additional_text}
                        </Typography>
                      ) : null}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : null}
        </Box>
      </Container>
    </Box>
  );
}
